import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Box, Grow } from '@material-ui/core';
import InfoCnaeCard from '../molecules/InfoCnae';
import DescriptionDetails from '../molecules/DescriptionDetails';
import Disclaimer from '../atoms/Disclaimer';
import HeaderDetailsMobile from '../molecules/HeaderDetailsMobile';
import HeaderDetailsDesktop from '../molecules/HeaderDetailsDesktop';
import Flag from '../molecules/Flag';
const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    borderRadius: '8px',
    background: '#FFF',
  },
  wrapper: {
    padding: '36px 24px',
  },

  flag: {
    marginTop: '16px'
  },

  informations: {
    display: 'flex',
    width: '100%',
    paddingBottom: '24px',
    borderBottom: `0.6px solid ${theme.palette.gray.lightGray}`
  },
}));

export default function CnaeDetails({ closeDrawer, currentCnae }) {
  const classes = useStyles();

  return (
    <>
    {currentCnae
      ? (
        <Grow in timeout={300}>
          <Box className={classes.container}>
            <Box className={classes.wrapper}>
              <HeaderDetailsMobile closeDrawer={closeDrawer} />
              <HeaderDetailsDesktop />
              <Box className={classes.informations}>
                <InfoCnaeCard />
              </Box>
              <Box className={classes.flag}>
                <Flag type={currentCnae.simplesNacional}/>
              </Box>
              <DescriptionDetails
                title={'Atividades'}
                activities={currentCnae.atividades}
              />
              <DescriptionDetails
                title={'Compreende'}
                activities={currentCnae.compreende}
              />
              <DescriptionDetails
                withoutBorder
                title={'Não compreende'}
                activities={currentCnae.naoCompreende}
              />
              <Disclaimer />
            </Box>
          </Box>
        </Grow>

        )
      : (
      <div></div>
        )}
    </>
  );
}

CnaeDetails.propTypes = {
  closeDrawer: PropTypes.func.isRequired,
  currentCnae: PropTypes.object
};
